import type { HTMLAttributes, ReactNode } from "react";

import clsx from "clsx";
import Image from "next/image";

import type { ImageMedia } from "@/src/domain/model/ImageMedia";

type ImageWithCaptionProps = {
  readonly cover?: boolean;
  readonly image: ImageMedia;
} & HTMLAttributes<HTMLDivElement>;

export function ImageWithCaption({
  className,
  cover = false,
  image,
}: ImageWithCaptionProps): ReactNode {
  return (
    <figure
      className={clsx("relative w-full", { "h-full": cover }, className)}
      key={image.id}
    >
      <Image
        alt={image.alt ?? ""}
        className={clsx("bubble-3xl w-full", {
          "h-full object-cover": cover,
        })}
        height={image.height}
        src={image.url}
        width={image.width}
      />
      {image.caption ? (
        <figcaption className="font-medium-antialiased bubble-xl absolute inset-x-4 top-4 w-fit bg-white/90 px-2 py-1 text-sm shadow-sm">
          {image.caption}
        </figcaption>
      ) : null}
    </figure>
  );
}
